import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';

const splitCopyIntoParagraphs = (content) => {
  content = content.split(/\n\s*\n/g).map(line => `<p>${line}</p>`).join('');

  return content
}

class FestivalEventCard extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    overLayStatus: 'none',
    eventTitleStatus: 'table-cell',
    eventCardWidth: 0
  }

  handleMouseOver = (e) => {
    if (this.props.browser.greaterThan.desktop) {
      this.setState({
        overLayStatus: 'table-cell',
        eventTitleStatus: 'none'
      });
    }
  }

  handleMouseOut = (e) => {
    if (this.props.browser.greaterThan.desktop) {
      this.setState({
        overLayStatus: 'none',
        eventTitleStatus: 'table-cell'
      });
    }
  }

  componentDidMount() {
    var eventCardWidth = '';

    eventCardWidth = document.getElementById('festivalEventCard').offsetWidth;

    this.setState({eventCardWidth: eventCardWidth})
  }

  componentWillReceiveProps(nextProps) {
    var eventCardWidth = '';

    eventCardWidth = document.getElementById('festivalEventCard').offsetWidth;

    this.setState({eventCardWidth: eventCardWidth})
  }

  render() {

    let event = this.props.event;
    let imgSrc = this.props.imgSrc;
    let overLayCopyHeight = '';
    let overLayCopyStyle = '';
    let eventTitleStyle = '';
    let eventCategoryUrl;

    eventCategoryUrl = '/girls-festival/program/' + event.id + '/' + event.slug;

    overLayCopyHeight = Math.round(this.state.eventCardWidth / .96);


    overLayCopyStyle = {
      width: '100%',
      height: `${overLayCopyHeight}`,
      display: `${this.state.overLayStatus}`
    }

    eventTitleStyle = {
      height: `${overLayCopyHeight}`,
      display: this.state.eventTitleStatus
    }

    function createMarkup(content) {
      return { __html: splitCopyIntoParagraphs(content).split('\n').join('<br/>') };
    }

    let htmlEventCopy;
    htmlEventCopy = <div dangerouslySetInnerHTML={createMarkup(event.event_copy)}></div>;


    return(

        <div onMouseOut={this.handleMouseOut.bind(this)} onMouseOver={this.handleMouseOver.bind(this)} className="festivalEventCard-outerWrapper" >

          <div id="festivalEventCard" className="festivalEventCard">

            <img src={imgSrc} />

            <div className="eventTitle" style={eventTitleStyle}>
              <h3>{event.event_title.toUpperCase()}</h3>
            </div>

            <div className="eventOverlay">
              <div className="eventOverlayCopyWrapper" style={overLayCopyStyle}>

                <div id="eventOverlayCopy-copy" className="eventOverlayCopy-copy" style={overLayCopyStyle}>
                  {htmlEventCopy}
                </div>

              </div>

            </div>

          </div>

        </div>


    )
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    Link
  }
)(FestivalEventCard);



// WEBPACK FOOTER //
// ./src/components/festival/FestivalEventCard.jsx